import { render, staticRenderFns } from "./edit.events.page.vue?vue&type=template&id=2062fb8e&"
import script from "./edit.events.page.vue?vue&type=script&lang=js&"
export * from "./edit.events.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports